export const ACTIVE_PERSONA_SESSION_KEY = 'activePersonaId';
export const DEFAULT_PERSONA_STORAGE_KEY = 'defaultPersonaId';

export function readActivePersonaId(): string | null {
  if (typeof window === 'undefined') return null;
  return (
    sessionStorage.getItem(ACTIVE_PERSONA_SESSION_KEY) ||
    localStorage.getItem(DEFAULT_PERSONA_STORAGE_KEY)
  );
}

export function writeActivePersonaId(personaId: string): void {
  const id = personaId.trim().toLowerCase();
  sessionStorage.setItem(ACTIVE_PERSONA_SESSION_KEY, id);
  localStorage.setItem(DEFAULT_PERSONA_STORAGE_KEY, id);
}

export function personaRequestHeaders(): Record<string, string> {
  const id = readActivePersonaId();
  return id ? { 'X-Persona-Id': id } : {};
}
